import { render, staticRenderFns } from "./brand-department-popup-content.vue?vue&type=template&id=9659a3f4&scoped=true&"
import script from "./brand-department-popup-content.vue?vue&type=script&lang=js&"
export * from "./brand-department-popup-content.vue?vue&type=script&lang=js&"
import style0 from "./brand-department-popup-content.vue?vue&type=style&index=0&id=9659a3f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9659a3f4",
  null
  
)

export default component.exports